import { createFileRoute, notFound } from "@tanstack/react-router";

import LandingNotFound from "@/components/landing/LandingNotFound";
import LandingPageView from "@/components/landing/LandingPageView";
import { landingPageContent } from "@/content/landing/source";
import { cmsPageHead, cmsPageHeaders } from "@/routing/cmsPageRoute";

/**
 * The campaign pages ads and partner sites link to: landing pages like any
 * other, kept under `/l/` as they were on Webflow, hidden from search engines
 * (their documents set "Hide from search engines") and left out of the
 * sitemap and robots.txt's crawl, which disallows the folder.
 */
export const Route = createFileRoute("/l/$slug")({
  loader: async ({ params }) => {
    const page = await landingPageContent({ data: `/l/${params.slug}` });
    if (!page) {
      throw notFound();
    }
    return page;
  },
  headers: cmsPageHeaders,
  head: cmsPageHead,
  component: CampaignRoute,
  notFoundComponent: LandingNotFound,
});

function CampaignRoute() {
  return <LandingPageView page={Route.useLoaderData()} />;
}
